import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import VariantesTable from "../Variantes/VariantesTable"
import { VariantesView } from "./VariantesView"
import { VariantesDelete } from "./VariantesDelete"
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import IconButton from '@mui/material/IconButton';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

import authService from '../api-authorization/AuthorizeService'
import { Breadcrumbs } from '../General/Breadcrumbs';

export class Variantes_Index extends Component {
    static displayName = Variantes_Index.name;
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { nombre: "", calibre_Id: 0, cajasPorPaleta_Id: 0 },
            etiquetaCore: {},
            calibres: [],
            cajasPorPaleta: [],
            paises: [],
        };
        this.load_etiquetaCore = this.load_etiquetaCore.bind(this);
        this.load_calibres = this.load_calibres.bind(this);
        this.load_cajasPorPaleta = this.load_cajasPorPaleta.bind(this);
        this.load_paises = this.load_paises.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="retailVariantId">
                                        <FormattedMessage id='RetailVariantId' />
                                    </Label>
                                    <Input
                                        id="retailVariantId"
                                        name="retailVariantId"
                                        type="text"
                                        onChange={this.handleSearchChange}
                                        value={this.state.searchModel.retailVariantId}
                                    />

                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="nombre">
                                        <FormattedMessage id='VariantName' />
                                    </Label>
                                    <Input
                                        id="nombre"
                                        name="nombre"
                                        type="text"
                                        onChange={this.handleSearchChange}
                                        value={this.state.searchModel.nombre}
                                    />

                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="calibre_Id">
                                        <FormattedMessage id='Calibre' />
                                    </Label>
                                    <Input
                                        id="calibre_Id"
                                        name="calibre_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.calibres.map(calibre => calibre.calibre_Id == this.state.searchModel.calibre_Id ? (
                                            <option value={calibre.calibre_Id} selected>
                                                {calibre.calibre}
                                            </option>
                                        ) : (<option value={calibre.calibre_Id}>{calibre.calibre}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="cajasPorPaleta_Id">
                                        <FormattedMessage id='CajasPorPaleta' />
                                    </Label>
                                    <Input
                                        id="cajasPorPaleta_Id"
                                        name="cajasPorPaleta_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.cajasPorPaleta.map(cajasPorPaleta => cajasPorPaleta.cajasPorPaleta_Id == this.state.searchModel.cajasPorPaleta_Id ? (
                                            <option value={cajasPorPaleta.cajasPorPaleta_Id} selected>
                                                {cajasPorPaleta.cantidad}
                                            </option>
                                        ) : (<option value={cajasPorPaleta.cajasPorPaleta_Id}>{cajasPorPaleta.cantidad}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="pais_Id">
                                        <FormattedMessage id='Pais' />
                                    </Label>
                                    <Input
                                        id="pais_Id"
                                        name="pais_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.paises.map(pais => pais.pais_Id == this.state.searchModel.pais_Id ? (
                                            <option value={pais.pais_Id} selected>
                                                {pais.nombre}
                                            </option>
                                        ) : (<option value={pais.pais_Id}>{pais.nombre}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <VariantesTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal size="xl" isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/EtiquetasCore", message: "EtiquetasCore", active: true },
                { link: "/EtiquetasCore/" + this.state.etiquetaCore.etiquetaCore_Id + "/Variantes", message: "Variantes", active: false },
            ]} />;
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();


        return (
            <div style={{ width: '100%' }}>
                <h2><FormattedMessage id='Variantes' /></h2>
                {breadcrumbsData}

                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Producto' />: {this.state.etiquetaCore.producto}</div>
                        <div className="px-4 py-2"><FormattedMessage id='EtiquetaCore' />: {this.state.etiquetaCore.nombre}</div>
                    </div>
                    <div className="d-flex justify-content-start">
                        {/*<div className="px-4 py-2"><FormattedMessage id='Producto' />: {this.state.proveedor.producto}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='Contenedor' />: {this.state.contenedorSemanal.contenedor}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='EtiquetaEspecial' />: {this.state.contenedorSemanal.etiquetaEspecial}</div>*/}
                    </div>
                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({
            loading: true,
            etiquetaCore: await this.load_etiquetaCore(),
        }, async () => {
            this.setState({
                calibres: await this.load_calibres(),
                cajasPorPaleta: await this.load_cajasPorPaleta(),
                paises: await this.load_paises(),
            }, async () => {
                const token = await authService.getAccessToken();
                var queryString = '?etiquetaCore_Id=' + this.state.etiquetaCore.etiquetaCore_Id + '&';
                Object.keys(this.state.searchModel).forEach(key => {
                    queryString += key + "=" + this.state.searchModel[key] + "&";
                });
                queryString = queryString.slice(0, -1);
                const response = await fetch('api/variantes' + queryString, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                });
                const responceData = await response.json();
                this.setState({ data: responceData, loading: false });

            });
        });
        
    }

    handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, () => {

        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><VariantesView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></VariantesView></div>);
        //return (<div><VariantesView ref={this.modalBodyState}></VariantesView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/variantes', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantes/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><VariantesView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></VariantesView></div>);
        //return (<div><VariantesView ref={this.modalBodyState}></VariantesView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/variantes/' + this.modalBodyState.variante_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantes/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><VariantesDelete setModalBodyState={this.setModalBodyState} data={responceData}></VariantesDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantes/' + this.modalBodyState.variante_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { nombre: "" }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_etiquetaCore() {
        var rawUrl = window.location.toString();
        var etiquetaCore_Id = rawUrl.split("EtiquetasCore/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore/' + etiquetaCore_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_calibres() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/calibres?producto_Id=' + this.state.etiquetaCore.producto_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_cajasPorPaleta() {
        const token = await authService.getAccessToken();
        console.log("this.state.etiquetaCore",this.state.etiquetaCore);
        const response = await fetch('api/cajasPorPaleta?producto_Id=' + this.state.etiquetaCore.producto_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_paises() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paises/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
}